<template>
	<v-overlay
		:model-value="displayCookieConsent"
		class="d-flex align-end justify-center"
		persistent
	>
		<BaseCard
			data-test="cookie-banner"
			color="primary"
			:title="translate('component.cookie.title')"
			:text="translate('component.cookie.text')"
		>
			<v-card-actions>
				<v-spacer v-if="productionMode"></v-spacer>
				<ButtonIcon
					color="primary"
					data-test="submit-btn"
					icon="fal fa-thumbs-up"
					text="Okay"
					@click="consentToCookies"
				></ButtonIcon>
				<ButtonIcon
					data-test="info-btn"
					href="https://www.hausperfekt.de/datenschutz/"
					icon="fal fa-info"
					target="_blank"
					text="Infos"
				></ButtonIcon>
			</v-card-actions>
		</BaseCard>
	</v-overlay>
</template>
<script setup lang="ts">
import { useUserStore } from '@/stores/system'
import { storeToRefs } from 'pinia'
import { computed, onMounted, ref } from 'vue'
import BaseCard from 'templates/Card/BaseCard.vue'
import { useTranslate } from 'composables/useTranslate.ts'

const { cookieConsent } = storeToRefs(useUserStore())
const { translate } = useTranslate()
const displayCookieConsent = computed(() => !cookieConsent.value)

function consentToCookies() {
	cookieConsent.value = true
}

const productionMode = ref()

onMounted(() => {
	productionMode.value = import.meta.env.PROD
})
</script>
